'kiwi public';

import _Reflect$construct from "@babel/runtime-corejs3/core-js-stable/reflect/construct";
import _classCallCheck from "@babel/runtime-corejs3/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime-corejs3/helpers/esm/createClass";
import _possibleConstructorReturn from "@babel/runtime-corejs3/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime-corejs3/helpers/esm/getPrototypeOf";
import _inherits from "@babel/runtime-corejs3/helpers/esm/inherits";
import _JSON$stringify from "@babel/runtime-corejs3/core-js-stable/json/stringify";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? _Reflect$construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(_Reflect$construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import EventEmitter from 'eventemitter3';
var IpcBroadcastChannel = /*#__PURE__*/function (_EventEmitter) {
  function IpcBroadcastChannel() {
    _classCallCheck(this, IpcBroadcastChannel);
    return _callSuper(this, IpcBroadcastChannel, arguments);
  }
  _inherits(IpcBroadcastChannel, _EventEmitter);
  return _createClass(IpcBroadcastChannel, [{
    key: "init",
    value: function init() {
      try {
        // Privacy settings in firefox 104~ block broadcast channels in iframes
        this.bc = new BroadcastChannel('kiwi-ipc');
        this.bc.onmessage = this.onmessage.bind(this);
      } catch (_unused) {
        // catch
      }
    }
  }, {
    key: "send",
    value: function send(msg) {
      if (this.bc) {
        this.bc.postMessage(msg);
      }
    }
  }, {
    key: "onmessage",
    value: function onmessage(msg) {
      this.emit('message', msg);
    }
  }]);
}(EventEmitter);
var IpcLocalStorage = /*#__PURE__*/function (_EventEmitter2) {
  function IpcLocalStorage() {
    _classCallCheck(this, IpcLocalStorage);
    return _callSuper(this, IpcLocalStorage, arguments);
  }
  _inherits(IpcLocalStorage, _EventEmitter2);
  return _createClass(IpcLocalStorage, [{
    key: "init",
    value: function init() {
      window.addEventListener('storage', this.onmessage.bind(this));
    }
  }, {
    key: "send",
    value: function send(msg) {
      localStorage.setItem('kiwi-ipc', _JSON$stringify(msg));
      localStorage.removeItem('kiwi-ipc');
    }
  }, {
    key: "onmessage",
    value: function onmessage(msg) {
      if (msg.key === 'kiwi-ipc' && msg.newValue) {
        try {
          var parsedMsg = {
            data: JSON.parse(msg.newValue)
          };
          this.emit('message', parsedMsg);
        } catch (e) {
          this.emit('error');
        }
      }
    }
  }]);
}(EventEmitter);
export default window.BroadcastChannel ? new IpcBroadcastChannel() : new IpcLocalStorage();
window._kiwi_exports = window._kiwi_exports || {};
if(!window._kiwi_exports["libs"]) window._kiwi_exports["libs"] = {};
window._kiwi_exports["libs"]["IPC"]
window._kiwi_exports.libs.IPC = (typeof exports !== 'undefined' ? (exports.default || exports) : (typeof module !== 'undefined' && module.exports ? (module.exports.default || module.exports) : {}));
